import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { PurchaseRequestLogModel }    from '../../app/reports/models/purchase-request.log';
import { Table }                      from '../table/types/table';
import { TableQueryParameters }       from '../table/types/table-query-parameters';
import { VehicleRegistrationService } from './vehicle-registration.service';

@Component({
  selector   : 'wor-vehicle-registration-lookups',
  template: require('./vehicle-registration.lookups.component.html')
})
export class VehicleRegistrationLookupsComponent {
  @Input() lookups: Array<PurchaseRequestLogModel> = [];

  tableSettings: Table = {
    columns: [
      {
        field : 'username',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        field : 'request_note',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.LOOKUP')
        }
      },
      {
        field : 'request_time',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe    : 'globalDate',
        pipeArgs: 'MMM d, yyyy h:mm a'
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
        type: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.REGISTRATION_LOOKUPS')
      })
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => this.vehicleRegistrationService.getLookupCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    }
  };

  constructor (
    private vehicleRegistrationService: VehicleRegistrationService,
    private translateService          : TranslateService
  ) {}

  get ( params : TableQueryParameters ) : Promise<Array<PurchaseRequestLogModel>> {
    return this.vehicleRegistrationService.getLookups(params)
      .then(( lookups : Array<PurchaseRequestLogModel> ) => {
        this.lookups = lookups;

        return lookups;
      });
  }
}
